import { Component, computed, input } from '@angular/core';
import { Product, TextNodeType } from '@mwe/models';
import { ServiceStateEnum } from '@mwe/constants';
import { isProductFernwaerme } from '@mwe/utils';
import { TariffCardTemplateComponent } from './tariff-card-template.component';
import { AsyncPipe } from '@angular/common';
import { TranslateCategoryPipe, TranslateTariffClassPipe } from '@mwe/ui/pipes';

@Component({
  selector: 'mwe-product-tariff-card-template',
  templateUrl: './product-tariff-card-template.component.html',
  imports: [TariffCardTemplateComponent, AsyncPipe, TranslateCategoryPipe, TranslateTariffClassPipe],
})
export class ProductTariffCardTemplateComponent {
  product = input<Product>();
  hasDiscount = input<boolean>();
  state = input<ServiceStateEnum>();
  headlineReference = input<TextNodeType>('p');
  hasActions = input<boolean>();
  hasContent = input<boolean>(true);
  isSpot = input<boolean>(false);
  spotUrl = input<string>('');
  isWaerme = computed<boolean>(() => isProductFernwaerme(this.product()));
}
